import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Container } from 'reactstrap';
import ManageProfile from './ManageProfile'

const UserProfile = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Admin Settings" title="User Profiles" mainTitle="User Profiles" />
            <Container fluid={true}>
                <ManageProfile />
            </Container>
        </Fragment>
    )
}

export default UserProfile